import { Route } from '@angular/router';
import { initialDataResolver } from 'app/app.resolvers';
import { AuthGuard } from 'app/core/auth/guards/auth.guard';
import { NoAuthGuard } from 'app/core/auth/guards/noAuth.guard';
import { LayoutComponent } from 'app/layout/layout.component';
import { permissionGuard } from './modules/auth/permission.guard';

export const appRoutes: Route[] = [
    // Redirect empty path to '/example'
    { path: '', pathMatch: 'full', redirectTo: 'dashboards' },

    // Redirect signed-in user to the '/example'

    {
        path: '',
        component: LayoutComponent,
        data: {
            layout: 'empty',
        },
        children: [
            {
                path: 'user-notification',
                loadComponent: () =>
                    import(
                        'app/modules/client/notification/user-notification/user-notification.component'
                    ).then((m) => m.UserNotificationComponent),
            },
            {
                path: 'user-notification-v2',
                loadComponent: () =>
                    import(
                        './modules/client/notification/user-notification-v2/user-notification-v2.component'
                    ).then((m) => m.UserNotificationV2Component),
            },
            {
                path: 'user-notification-individual',
                loadComponent: () =>
                    import(
                                                './modules/client/notification/individual-notification/individual-notification.component'

                    ).then((m) => m.IndividualNotificationComponent),
            },
        ],
    },

    //Auth routes
    {
        path: '',
        // canActivate: [NoAuthGuard],
        canActivateChild: [NoAuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty',
        },
        children: [
            {
                path: 'login',
                loadChildren: () =>
                    import('app/modules/auth/login/login.routes'),
            },
            {
                path: 'reset-password',
                loadChildren: () =>
                    import(
                        'app/modules/auth/reset-password/reset-password.routes'
                    ),
            },
        ],
    },

    //dashbard routes
    {
        path: '',
        canActivate: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: initialDataResolver,
        },
        children: [
            // {
            //     path: 'example',
            //     loadChildren: () =>
            //         import('app/modules/admin/example/example.routes'),
            // },
            {
                path: 'welcome',
                loadChildren: () =>
                    import('app/modules/client/welcome/welcome.routes'),
            },
            {
                path: 'request',
                loadChildren: () =>
                    import('app/modules/request/request.routes').then(
                        (m) => m.requestRoutes
                    ),
            },
            {
                path: 'reimbursement',
                loadChildren: () =>
                    import(
                        'app/modules/client/reimbursement/reimbursement.routes'
                    ).then((m) => m.reimbursementRoutes),
            },
            {
                path: 'profile',
                loadChildren: () =>
                    import('app/modules/client/profile/profile.routes'),
            },

            {
                path: 'dashboards',
                children: [
                    {
                        path: '',
                        loadChildren: () =>
                            import('app/modules/admin/example/example.routes'),
                    },
                ],
                // canActivate:[permissionGuard],
                // data:{accessKey:['user.dashboard']}
            },

            {
                path: 'attendance',
                loadChildren: () =>
                    import(
                        'app/modules/client/attendance/attendance.routes'
                    ).then((m) => m.attendanceRoutes),
            },
            {
                path: 'onboarding',
                loadChildren: () =>
                    import(
                        'app/modules/client/onboarding/onboarding.routes'
                    ).then((m) => m.onboardingRoutes),
            },

            {
                path: 'allowances',
                loadChildren: () =>
                    import(
                        'app/modules/client/allowance/allowance.routes'
                    ).then((m) => m.allowanceRoutes),
            },
            {
                path: 'investment-declaration',
                loadChildren: () =>
                    import(
                        'app/modules/client/investment-declaration/investment-declaration.routes'
                    ).then((m) => m.investmentDeclarationRoutes),
                canActivate: [permissionGuard],
                data: {
                    accessKey: [
                        'InvestmentDeclaration.create',
                        'employeeDeclaredInvestment.list',
                        'employeeDeclaredInvestment.approve',
                    ],
                },
            },
            {
                path: 'proposed-investment',
                loadChildren: () =>
                    import(
                        'app/modules/client/proposed-investment/proposed-investment.routes'
                    ).then((m) => m.proposedInvestmentRoutes),
                canActivate: [permissionGuard],
                data: {
                    accessKey: [
                        'proposedInvestment.create',
                        'employeeProposedInvestment.list',
                        'employeeProposedInvestment.approve',
                    ],
                },
            },
            {
                path: 'not-found',
                loadChildren: () =>
                    import('app/modules/client/error-404/error-404.routes'),
            },
            {
                path: 'auth-controller',
                loadChildren: () =>
                    import(
                        'app/modules/client/auth-controller/auth-controller.route'
                    ).then((m) => m.authController),
            },
            {
                path: 'investment',
                loadChildren: () =>
                    import(
                        'app/modules/client/investment-list/investment-list.routes'
                    ).then((m) => m.investmentListRoutes),
            },
            {
                path: 'file-upload-logs',
                loadChildren: () =>
                    import(
                        'app/modules/client/file-upload-logs/file-upload-logs.routes'
                    ),
                canActivate: [permissionGuard],
                data: { accessKey: 'fileUploadLogs.list' },
            },
            {
                path: 'masters',
                loadChildren: () =>
                    import('app/modules/client/masters/masters.routes').then(
                        (m) => m.MastersRoutes
                    ),
            },
            {
                path: 'group-medical-insurance/list',
                canActivate: [permissionGuard],
                data: { accessKey: 'notifications.list' },
                loadChildren: () =>
                    import(
                        'app/modules/client/notification/notification.routes'
                    ),
            },
            {
                path: 'notifications',
                canActivate: [permissionGuard],
                data: { accessKey: 'notifications.list' },
                loadChildren: () =>
                    import(
                        'app/modules/client/notification/notification.routes'
                    ),
            },

            {
                path: 'whitelabel-configuration',
                loadChildren: () =>
                    import(
                        'app/modules/client/whitelabel-configuration/whitelabel-configuration.routes'
                    ).then((m) => m.whiteLabelConfigurationRoutes),
            },
        ],
    },
    {
        path: '**',
        redirectTo: 'dashboards',
    },
];
